<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style src="./style.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-vibrant.scss" lang="scss"></style>

<script>

export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: '%s - Fitlist'
  },
  data: () => ({
    authenticated: false
  }),
  methods: {
    setAuthenticated: function (status) {
      this.authenticated = status
    },
    logout: function () {
      this.authenticated = false
    }
  },
  created: function () {
    // redirect to signin if no user data found in localStorage
    /*const token = this.$store.getters.userToken

    if (token == null && !this.hasCheckedAuth) {
      this.$router.push('/signin/login')
      this.hasCheckedAuth = true
    }*/
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  }
}
</script>
